/* Initial values */
let didScroll;
let lastScrollTop = 0;
const delta = 5;
const header = document.querySelector('header');
const headerHeight = header.offsetHeight;

const body = document.querySelector('body');
const nav = document.querySelector('header > .toolbar > nav');
const menuToggle = document.getElementById('menu-toggle');
const menuIcon = document.querySelector('.menu-icon');

const mainDropdownBtn = document.querySelector('.header-dropdown-button a');
const mainDropdownBtnSpan = document.createElement('span');
const mainSubMenu = document.querySelector('.header-dropdown-button .sub-menu');
const mainSubMenuItems = document.querySelectorAll('.header-dropdown-button .sub-menu .menu-item');
const overlay = document.querySelector('.overlay');
const searchLink = document.querySelector('.search-link');

mainDropdownBtn && mainDropdownBtn.classList.add('header-dropdown-link');

const isCampaign = body.classList.contains('campaign');

window.onscroll = () => {
    didScroll = true;
};

// Hide header on scroll down, show on scroll up start
const headerHasScrolled = () => {
    const st = document.body.scrollTop || document.documentElement.scrollTop;

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // Check if the navigation is visible
    const navVisible = document.querySelector('nav')?.classList.contains('visible');

    if (!navVisible) {
        if (st > lastScrollTop && st > headerHeight) {
            // Scroll Down
            header.classList.add('header-up');
        } else {
            // Scroll Up
            header.classList.remove('header-up');
        }
    }

    lastScrollTop = st;
};

// Run headerHasScrolled() every 250ms if user has scrolled
setInterval(() => {
    if (didScroll) {
        headerHasScrolled();
        didScroll = false;
    }
}, 250);

// Toggle mobile menu
const menuToggleHandler = () => {
    const chatIframe = document.querySelector('#magic-widget-launcher-parent');

    if (nav.classList.contains('visible')) {
        // Enable scrolling
        body.style.overflow = null;
        // Hide mobile menu
        nav.classList.remove('visible');
        // Change menu icon
        menuIcon.textContent = 'menu';
        // Show chat iframe
        chatIframe && (chatIframe.style.display = 'block');
    } else {
        // Disable scrolling
        body.style.overflow = 'hidden';
        // Show mobile menu
        nav.classList.add('visible');
        // Change menu icon
        menuIcon.textContent = 'close';
        // Hide chat iframe
        chatIframe && (chatIframe.style.display = 'none');
    }
};

// Toggle mobile menu start
menuToggle && menuToggle.addEventListener('click', menuToggleHandler);

// Add click event to header dropdown button that toggles the sub menu
mainDropdownBtn &&
    mainDropdownBtn.addEventListener('click', e => {
        e.preventDefault();
        mainSubMenu.classList.toggle('show');
        overlay.classList.toggle('visible');
        mainDropdownBtn.classList.toggle('show');

        if (mainSubMenu.classList.contains('show')) {
            mainDropdownBtnSpan.innerText = 'expand_less';
        } else {
            mainDropdownBtnSpan.innerText = 'expand_more';
        }
    });

// If viewport is less than 1024 pixels, show the mainSubMenu by default
if (window.innerWidth <= 1024) {
    // nav.classList.add('visible');
    mainSubMenu && mainSubMenu.classList.add('show');
}

// Close dropdown menu if user clicks outside of it if it is open and viewport is more than 1024 pixels
window.addEventListener('click', e => {
    if (window.innerWidth > 1024) {
        if (
            mainSubMenu?.classList.contains('show') &&
            !e.target.closest('.header-dropdown-button')
        ) {
            overlay.classList.remove('visible');
            mainSubMenu.classList.remove('show');
            mainDropdownBtnSpan.innerText = 'expand_more';
        }
    }
});

// Add span element to header dropdown button
mainDropdownBtnSpan.innerText = 'expand_more';
mainDropdownBtnSpan.classList.add('material-symbols-outlined', 'header-dropdown-icon');
mainDropdownBtn && mainDropdownBtn.appendChild(mainDropdownBtnSpan);

// Add click event to all sub menu items that closes the sub menu
mainSubMenuItems.forEach(item => {
    item.addEventListener('click', () => {
        mainSubMenu.classList.remove('show');
        mainDropdownBtnSpan.innerText = 'expand_more';
    });
});

// Add html in each sub-menu-items a tag
const mainSubMenuContent = [
    {
        imageUrl: 'https://norskluftambulanse.no/wp-content/uploads/2021/08/113-app-scaled.jpg',
        text: 'Vi utvikler til enhver tid nye løsninger for at syke og skadde pasienter skal få best mulig behandling. Målet er at vår innovasjon skal tas i bruk og gjøre luftambulansetjenesten enda bedre.'
    },
    {
        imageUrl:
            'https://norskluftambulanse.no/wp-content/uploads/2021/08/FNA_200619_0031-scaled.jpg',
        text: 'Vi forsker på pasientbehandling, nye prosedyrer og medikamenter, og er blant Europas ledende forskningsinstitusjoner innen akuttmedisin. I samarbeid med helseforetak og universiteter i hele landet gjør vi tjenesten enda bedre.'
    },
    {
        imageUrl:
            'https://norskluftambulanse.no/wp-content/uploads/2020/12/Norsk-Luftambulanse_Camp-Torpmoen_049.jpg',
        text: 'Kunnskap må deles og kompetanse må læres. Derfor trener vi luftambulansepersonell, ambulansearbeidere, politi og brannvesen for at vi sammen skal bli bedre, og sammen redde flere liv.'
    }
];

// Add html in each sub-menu-items a tag
mainSubMenuItems.forEach((item, idx) => {
    const itemLink = item.querySelector('a');
    itemLink.classList.add('sub-menu-item-link');
    const itemLinkText = itemLink.innerText;
    itemLink.innerHTML = `
        <h5 class="sub-menu-item-title">${itemLinkText}</h5>
        <div class="sub-menu-item-content">
            <div class="sub-menu-item-content-left">
                <div class="image-container">
                    <img src="${mainSubMenuContent[idx].imageUrl}" alt="Test-image">
                </div>
                <div class="item-btn">
                    <span>${itemLinkText}</span>
                    <span class="material-symbols-outlined">arrow_forward</span>
                </div>
            </div>
            <div class="sub-menu-item-content-right">
                <p>${mainSubMenuContent[idx].text}</p>
            </div>
        </div>
    `;
});

// Function to update the cart count in the header
const cartMenuItem = document.querySelector('.shopping-cart-item a');
cartMenuItem && (cartMenuItem.textContent = '');
cartMenuItem &&
    (cartMenuItem.innerHTML = `
        <span class="cart-count">0</span>
        <span class="material-symbols-outlined cart-icon">shopping_bag</span>
        `);

// Function to update the cart count in the header
window.updateCartCount = function () {
    // eslint-disable-next-line no-undef
    let cart;
    try {
        cart = JSON.parse(localStorage.getItem('snla-cart'));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to access localStorage. Error:', error);
        cart = [];
    }
    const cartCount = cart ? cart.reduce((total, item) => total + item.qty, 0) : 0;
    const cartCountElement = document.querySelector('.cart-count');
    const cartIconElement = document.querySelector('.cart-icon');
    const cartMenuItem = document.querySelector('.shopping-cart-item a');

    cartCountElement && (cartCountElement.textContent = cartCount);

    if (cartCount !== 0) {
        cartCountElement && (cartCountElement.style.display = 'flex');
        cartIconElement && (cartIconElement.textContent = 'shopping_cart');
        cartMenuItem && (cartMenuItem.href = '/nettbutikk/handlevogn/');
    } else {
        cartCountElement && (cartCountElement.style.display = 'none');
        cartIconElement && (cartIconElement.textContent = 'shopping_bag');
        cartMenuItem && (cartMenuItem.href = '/nettbutikk/');
    }
};

// Update the cart count in the header on page load
window.addEventListener('DOMContentLoaded', event => {
    window.updateCartCount();

    // Update the cart count in the header when the cart is updated
    window.addEventListener('storage', event => {
        if (event.key === 'snla-cart') {
            window.updateCartCount();
        }
    });
});

// Add click event to search link that hides the link, and shows the search form
searchLink &&
    searchLink.addEventListener('click', e => {
        if (searchLink.classList.contains('show-input-field')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        searchLink.classList.add('show-input-field');

        if (searchLink.classList.contains('search-link-eng')) {
            searchLink.innerHTML = `
                <form id="search-header-form" role="search" action="/">
                <input type="search" name="s" aria-label="Search Norsk luftambulanses website" placeholder="Search" autocomplete="off">
                <input type="hidden" name="post_type" value="eng" />
                    <button type="submit" aria-label="Search">
                        <span class="material-symbols-outlined search-icon">search</span>
                    </button>
                </form>
            `;
        } else {
            searchLink.innerHTML = `
                <form id="search-header-form" role="search" action="/">
                    <input type="search" name="s" aria-label="Søk i Norsk luftambulanses nettsider" placeholder="Hva leter du etter?" autocomplete="off">
                    <button type="submit" aria-label="Søk">
                        <span class="material-symbols-outlined search-icon">search</span>
                    </button>
                </form>
            `;
        }

        // Focus on the input field
        searchLink.querySelector('input').focus();
    });

// Hide search form and show search link when user clicks outside of search form
window.addEventListener('click', e => {
    if (!e.target.closest('.search-link')) {
        searchLink?.classList.remove('show-input-field');
        if (!isCampaign && searchLink.classList.contains('search-link-eng')) {
            searchLink.innerHTML = '<a title="Search" href="#">Search</a>';
        } else {
            if (!isCampaign) {
                searchLink.innerHTML = '<a title="Søk" href="#">Søk</a>';
            }
        }
    }
});

// Reset header on resize
window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) {
        body.style.overflow = null;
        if (nav && nav.classList && nav.classList.contains('visible')) {
            nav.classList.remove('visible');
        }
        if (menuIcon) {
            menuIcon.textContent = 'menu';
        }
        if (overlay) {
            overlay.classList.remove('visible');
        }
        if (mainDropdownBtnSpan) {
            mainDropdownBtnSpan.innerText = 'expand_more';
        }
        if (mainSubMenu) {
            mainSubMenu.classList.remove('show');
        }
    }
});

/** NEW HEADER SCRIPTS END **/
/* Header block end */
